import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";

import Header from "@/components/layout/Header";
import Footer from "@/components/layout/Footer";
import ProtectedRoute from "@/components/ProtectedRoute";
import { AuthProvider } from "@/context/AuthContext";

import Home from "@/pages/Home";
import About from "@/pages/About";
import Services from "@/pages/Services";
import GetInvolved from "@/pages/GetInvolved";
import Refer from "@/pages/Refer";
import Contact from "@/pages/Contact";
import Login from "@/pages/Login";
import Privacy from "@/pages/Privacy";
import Terms from "@/pages/Terms";

import DashboardLayout from "@/pages/dashboard/DashboardLayout";
import DashboardHome from "@/pages/dashboard/DashboardHome";
import Referrals from "@/pages/dashboard/Referrals";
import ReferralDetail from "@/pages/dashboard/ReferralDetail";
import Volunteers from "@/pages/dashboard/Volunteers";
import Contacts from "@/pages/dashboard/Contacts";
import Members from "@/pages/dashboard/Members";
import StaffAdmin from "@/pages/dashboard/StaffAdmin";
import Clients from "@/pages/dashboard/Clients";
import ClientDetail from "@/pages/dashboard/ClientDetail";
import Tasks from "@/pages/dashboard/Tasks";
import Billables from "@/pages/dashboard/Billables";
import FormTemplates from "@/pages/dashboard/FormTemplates";
import MyProfile from "@/pages/dashboard/MyProfile";
import Shifts from "@/pages/dashboard/Shifts";
import Incidents from "@/pages/dashboard/Incidents";
import MyCalendar from "@/pages/dashboard/MyCalendar";
import PeerWorkers from "@/pages/dashboard/PeerWorkers";
import Roster from "@/pages/dashboard/Roster";
import Todos from "@/pages/dashboard/Todos";
import Directors from "@/pages/dashboard/Directors";
import Grants from "@/pages/dashboard/Grants";

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <div className="min-h-screen flex flex-col bg-njas-bg">
          <Header />
          <main className="flex-1">
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/about" element={<About />} />
              <Route path="/services" element={<Services />} />
              <Route path="/get-involved" element={<GetInvolved />} />
              <Route path="/refer" element={<Refer />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/privacy" element={<Privacy />} />
              <Route path="/terms" element={<Terms />} />
              <Route path="/login" element={<Login />} />

              <Route
                path="/dashboard"
                element={
                  <ProtectedRoute>
                    <DashboardLayout />
                  </ProtectedRoute>
                }
              >
                <Route index element={<DashboardHome />} />
                <Route path="referrals" element={<Referrals />} />
                <Route path="referrals/:id" element={<ReferralDetail />} />
                <Route path="clients" element={<Clients />} />
                <Route path="clients/:id" element={<ClientDetail />} />
                <Route path="tasks" element={<Tasks />} />
                <Route path="billables" element={<Billables />} />
                <Route path="calendar" element={<MyCalendar />} />
                <Route path="shifts" element={<Shifts />} />
                <Route path="incidents" element={<Incidents />} />
                <Route path="profile" element={<MyProfile />} />
                <Route path="volunteers" element={<Volunteers />} />
                <Route path="contacts" element={<Contacts />} />
                <Route path="members" element={<Members />} />
                <Route
                  path="form-templates"
                  element={
                    <ProtectedRoute adminOnly>
                      <FormTemplates />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="peer-workers"
                  element={
                    <ProtectedRoute adminOnly>
                      <PeerWorkers />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="staff"
                  element={
                    <ProtectedRoute adminOnly>
                      <StaffAdmin />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="roster"
                  element={<Roster />}
                />
                <Route
                  path="todos"
                  element={<Todos />}
                />
                <Route
                  path="directors"
                  element={
                    <ProtectedRoute adminOnly>
                      <Directors />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="grants"
                  element={<Grants />}
                />
              </Route>
            </Routes>
          </main>
          <Footer />
          <Toaster position="top-right" richColors closeButton />
        </div>
      </BrowserRouter>
    </AuthProvider>
  );
}
